import React from "react";

import { SvgIcon } from "@mui/material/";

const Menu = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 96 960 960">
      <path d="M146 784.769v-58h670v58H146ZM146 604v-58h670v58H146Zm0-178.769v-58h670v58H146Z" />
    </SvgIcon>
  );
};

export default Menu;
